import React, { 
    useEffect, 
    useState } from 'react';
import './index.scss';
import { InfoCell } from '../InfoCell';
import { EditDocumentData } from '../EditDocumentData';

export const DocumentData = ({metadata}) => {
    const [editDocumentData, setEditDocumentData] = useState(false);
    const [documentData, setDocumentData] = useState([]);

    useEffect(() => {
        mappingData(metadata)
    }, [metadata])

    const mappingData = (metadata) => {
        // setDocumentData(Object.keys(metadata).map((key) => {
        //     return {
        //         key: key,
        //         value: metadata[key]
        //     }
        // }))
        setDocumentData(Object.keys(metadata).map((key) => {
            return {
                key: key,
                value: typeof metadata[key] === 'object' ? ":string:" : metadata[key]
            }
        }));
        
    }

    const insertSpaceKey = (string) => {
        switch (string) {
            case "BLNumber":
                return "BL Number";
            case "ETA":
                return "ETA";
            case "IMONumber":
                return "IMO Number";
            case "TypeOfBL":
                return "Type Of BL";
            default:
                return string.replace(/([A-Z])/g, ' $1').trim();
        }
    }

    return editDocumentData ? (
        <EditDocumentData
            goBack={() => {
                setEditDocumentData(false);
            }}
        />
    ) : (
            <div className="col-8 doc--content">
                <div className="document-content">
                <h3 className="h3 f-medium mbx3">Document metadata</h3>
                    <div className='row'>
                    {documentData && documentData.length > 0 && documentData.map((data, index) => (
                            <div className="col-6 mbx2" key={index}>
                                <InfoCell
                                    className="col-sm-6"
                                    label={insertSpaceKey(data?.key)}
                                    value={!(data?.value?.slice(data?.value?.lastIndexOf(":") + 1)) ? "-" : (data?.value?.slice(data?.value?.lastIndexOf(":") + 1))}
                                    // label={"Booking date"}
                                    // value={!(metadata?.BookingDate.slice(metadata?.BookingDate.lastIndexOf(":") + 1)) ? "-" : (metadata?.BookingDate.slice(metadata?.BookingDate.lastIndexOf(":") + 1))}
                                />
                            </div>
                    ))}
                        {/* <h3 className="h3 f-medium">Document metadata</h3>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Carrier name"}
                                    value={!(metadata?.CarrierName.slice(metadata?.CarrierName.lastIndexOf(":") + 1)) ? "-" : (metadata?.CarrierName.slice(metadata?.CarrierName.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Booking number"}
                                    value={!(metadata?.BookingNumber.slice(metadata?.BookingNumber.lastIndexOf(":") + 1)) ? "-" : (metadata?.BookingNumber.slice(metadata?.BookingNumber.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Booking date"}
                                    value={!(metadata?.BookingDate.slice(metadata?.BookingDate.lastIndexOf(":") + 1)) ? "-" : (metadata?.BookingDate.slice(metadata?.BookingDate.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Shipper"}
                                    value={!(metadata?.Shipper.slice(metadata?.Shipper.lastIndexOf(":") + 1)) ? "-" : (metadata?.Shipper.slice(metadata?.Shipper.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Shipper Address"}
                                    value={!(metadata?.ShipperAddress.slice(metadata?.ShipperAddress.lastIndexOf(":") + 1)) ? "-" : (metadata?.ShipperAddress.slice(metadata?.ShipperAddress.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Consignee"}
                                    value={!(metadata?.Consignee.slice(metadata?.Consignee.lastIndexOf(":") + 1)) ? "-" : (metadata?.Consignee.slice(metadata?.Consignee.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Consignee Address"}
                                    value={!(metadata?.ConsigneeAddress.slice(metadata?.ConsigneeAddress.lastIndexOf(":") + 1)) ? "-" : (metadata?.ConsigneeAddress.slice(metadata?.ConsigneeAddress.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Notify Party"}
                                    value={!(metadata?.NotifyParty.slice(metadata?.NotifyParty.lastIndexOf(":") + 1)) ? "-" : (metadata?.NotifyParty.slice(metadata?.NotifyParty.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Notify Party Address"}
                                    value={!(metadata?.NotifyPartyAddress.slice(metadata?.NotifyPartyAddress.lastIndexOf(":") + 1)) ? "-" : (metadata?.NotifyPartyAddress.slice(metadata?.NotifyPartyAddress.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Service Contract Number"}
                                    value={!(metadata?.ServiceContractNumber.slice(metadata?.ServiceContractNumber.lastIndexOf(":") + 1)) ? "-" : (metadata?.ServiceContractNumber.slice(metadata?.ServiceContractNumber.lastIndexOf(":") + 1))}
                                />
                            </div>
                    </div> */}
                    
                </div>
                </div>
                {/* <div className='row'>
                        <h3 className="h3 f-medium">Contact Information</h3>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Shipper Contact"}
                                    value={!(metadata?.ContactInformation?.ShipperContact.slice(metadata?.ContactInformation?.ShipperContact.lastIndexOf(":") + 1)) ? "-" : (metadata?.ContactInformation?.ShipperContact.slice(metadata?.ContactInformation?.ShipperContact.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Shipper Fax"}
                                    value={!(metadata?.ContactInformation?.ShipperFax.slice(metadata?.ContactInformation?.ShipperFax.lastIndexOf(":") + 1)) ? "-" : (metadata?.ContactInformation?.ShipperFax.slice(metadata?.ContactInformation?.ShipperFax.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Consignee Contact"}
                                    value={!(metadata?.ContactInformation?.ConsigneeContact.slice(metadata?.ContactInformation?.ConsigneeContact.lastIndexOf(":") + 1)) ? "-" : (metadata?.ContactInformation?.ConsigneeContact.slice(metadata?.ContactInformation?.ConsigneeContact.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Consignee Fax"}
                                    value={!(metadata?.ContactInformation?.ConsigneeFax.slice(metadata?.ContactInformation?.ConsigneeFax.lastIndexOf(":") + 1)) ? "-" : (metadata?.ContactInformation?.ConsigneeFax.slice(metadata?.ContactInformation?.ConsigneeFax.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Notify Contact"}
                                    value={!(metadata?.ContactInformation?.NotifyContact.slice(metadata?.ContactInformation?.NotifyContact.lastIndexOf(":") + 1)) ? "-" : (metadata?.ContactInformation?.NotifyContact.slice(metadata?.ContactInformation?.NotifyContact.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Measurement"}
                                    value={!(metadata?.Measurement.slice(metadata?.Measurement.lastIndexOf(":") + 1)) ? "-" : (metadata?.Measurement.slice(metadata?.Measurement.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Container Yard"}
                                    value={!(metadata?.ContainerYard.slice(metadata?.ContainerYard.lastIndexOf(":") + 1)) ? "-" : (metadata?.ContainerYard.slice(metadata?.ContainerYard.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Vessels"}
                                    value={!(metadata?.Vessel.slice(metadata?.Vessel.lastIndexOf(":") + 1)) ? "-" : (metadata?.Vessel.slice(metadata?.Vessel.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"IMO"}
                                    value={!(metadata?.IMO.slice(metadata?.IMO.lastIndexOf(":") + 1)) ? "-" : (metadata?.IMO.slice(metadata?.IMO.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Voyage Number"}
                                    value={!(metadata?.VoyageNumber.slice(metadata?.VoyageNumber.lastIndexOf(":") + 1)) ? "-" : (metadata?.VoyageNumber.slice(metadata?.VoyageNumber.lastIndexOf(":") + 1))}
                                />
                            </div>
                            <div className="col-6 mbx2">
                                <InfoCell
                                    className="col-sm-6"
                                    label={"Commodity Description"}
                                    value={!(metadata?.CommodityDescription.slice(metadata?.CommodityDescription.lastIndexOf(":") + 1)) ? "-" : (metadata?.CommodityDescription.slice(metadata?.CommodityDescription.lastIndexOf(":") + 1))}
                                />
                            </div>
                    </div>
                    <div className='row'>
                        <h3 className="h3 f-medium">Gross weight</h3>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"Unit"}
                                value={!(metadata?.GrossWeight?.Unit.slice(metadata?.GrossWeight?.Unit.lastIndexOf(":") + 1)) ? "-" : (metadata?.GrossWeight?.Unit.slice(metadata?.GrossWeight?.Unit.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="Value"
                                label={"Shipper Contact"}
                                value={!(metadata?.GrossWeight?.Value.slice(metadata?.GrossWeight?.Value.lastIndexOf(":") + 1)) ? "-" : (metadata?.GrossWeight?.Value.slice(metadata?.GrossWeight?.Value.lastIndexOf(":") + 1))}
                            />
                        </div>
                    </div> */}
                    {/* <div className='row'>
                        <h3 className="h3 f-medium">Shipping Information</h3>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"Origin Port"}
                                value={!(metadata?.ShippingInformation?.OriginPort.slice(metadata?.ShippingInformation?.OriginPort.lastIndexOf(":") + 1)) ? "-" : (metadata?.ShippingInformation?.OriginPort.slice(metadata?.ShippingInformation?.OriginPort.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="Value"
                                label={"Destination Port"}
                                value={!(metadata?.ShippingInformation?.DestinationPort.slice(metadata?.ShippingInformation?.DestinationPort.lastIndexOf(":") + 1)) ? "-" : (metadata?.ShippingInformation?.DestinationPort.slice(metadata?.ShippingInformation?.DestinationPort.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"ETD"}
                                value={!(metadata?.ShippingInformation?.ETD.slice(metadata?.ShippingInformation?.ETD.lastIndexOf(":") + 1)) ? "-" : (metadata?.ShippingInformation?.ETD.slice(metadata?.ShippingInformation?.ETD.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"ETA"}
                                value={!(metadata?.ShippingInformation?.ETA.slice(metadata?.ShippingInformation?.ETA.lastIndexOf(":") + 1)) ? "-" : (metadata?.ShippingInformation?.ETA.slice(metadata?.ShippingInformation?.ETA.lastIndexOf(":") + 1))}
                            />
                        </div>
                    </div> */}
                    {/* <div className='row'>
                        <h3 className="h3 f-medium">Transhipment Information</h3>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"T S Port"}
                                value={!(metadata?.TranshipmentInformation[0]?.TSPort.slice(metadata?.TranshipmentInformation[0]?.TSPort.lastIndexOf(":") + 1)) ? "-" : (metadata?.TranshipmentInformation[0]?.TSPort.slice(metadata?.TranshipmentInformation[0]?.TSPort.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"T S Next Port"}
                                value={!(metadata?.TranshipmentInformation[0]?.TSNextPort.slice(metadata?.TranshipmentInformation[0]?.TSNextPort.lastIndexOf(":") + 1)) ? "-" : (metadata?.TranshipmentInformation[0]?.TSNextPort.slice(metadata?.TranshipmentInformation[0]?.TSNextPort.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div>
                             <InfoCell
                                className="col-sm-6"
                                label={"T S Vessel"}
                                value={!(metadata?.TranshipmentInformation[0]?.TSVessel.slice(metadata?.TranshipmentInformation[0]?.TSVessel.lastIndexOf(":") + 1)) ? "-" : (metadata?.TranshipmentInformation[0]?.TSVessel.slice(metadata?.TranshipmentInformation[0]?.TSVessel.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"T S Vessel I M O"}
                                value={!(metadata?.TranshipmentInformation[0]?.TSVesselIMO.slice(metadata?.TranshipmentInformation[0]?.TSVesselIMO.lastIndexOf(":") + 1)) ? "-" : (metadata?.TranshipmentInformation[0]?.TSVesselIMO.slice(metadata?.TranshipmentInformation[0]?.TSVesselIMO.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div>
                             <InfoCell
                                className="col-sm-6"
                                label={"TS ETD"}
                                value={!(metadata?.TranshipmentInformation[0]?.TSETD.slice(metadata?.TranshipmentInformation[0]?.TSETD.lastIndexOf(":") + 1)) ? "-" : (metadata?.TranshipmentInformation[0]?.TSETD.slice(metadata?.TranshipmentInformation[0]?.TSETD.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"TSETA"}
                                value={!(metadata?.TranshipmentInformation[0]?.TSETA.slice(metadata?.TranshipmentInformation[0]?.TSETA.lastIndexOf(":") + 1)) ? "-" : (metadata?.TranshipmentInformation[0]?.TSETA.slice(metadata?.TranshipmentInformation[0]?.TSETA.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div>
                             <InfoCell
                                className="col-sm-6"
                                label={"H S Code"}
                                value={!(metadata?.HSCode.slice(metadata?.HSCode.lastIndexOf(":") + 1)) ? "-" : (metadata?.HSCode.slice(metadata?.HSCode.lastIndexOf(":") + 1))}
                            />
                        </div>
                        <div className="col-6 mbx2">
                            <InfoCell
                                className="col-sm-6"
                                label={"Number Of ContainersPort"}
                                value={!(metadata?.NumberOfContainers.slice(metadata?.NumberOfContainers.lastIndexOf(":") + 1)) ? "-" : (metadata?.NumberOfContainers.slice(metadata?.NumberOfContainers.lastIndexOf(":") + 1))}
                            />
                        </div>
                    </div> */}
            </div>
    );
};

DocumentData.propTypes = {
};
